import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=0730898a"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=0730898a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports